















import Vue, { PropOptions } from 'vue';

interface IDot {
  component: string;
  key: number;
  attrs?: Record<string, string>;
  page?: string;
}

const DEFAULT_LOADING_DOT_COUNT = 5;

export default Vue.extend({
  name: 'BravadoInfiniteScrollLoader',
  props: {
    links: {
      type: Array,
      default: () => [],
    } as PropOptions<Array<string>>,
    dotCount: {
      type: Number,
      default: DEFAULT_LOADING_DOT_COUNT,
    } as PropOptions<number>,
    withLinks: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    dots(): Array<IDot> {
      return [...Array(this.dotCount).keys()].map((el, index) => {
        const key = el;
        if (!this.links[index] || this.withLinks === false) {
          return {
            component: 'div',
            key,
          };
        }
        const page = this.links[index].match(/\d*$/g)?.[0];

        return {
          component: 'a',
          key,
          attrs: { href: this.links[index] },
          page,
        };
      });
    },
  },
});
